import { render, staticRenderFns } from "./emploiTempteacher2.vue?vue&type=template&id=fdd507b6&"
import script from "./emploiTempteacher2.vue?vue&type=script&lang=js&"
export * from "./emploiTempteacher2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports